import { createContext } from '@companydotcom/potion';
import { Notification } from '@companydotcom/types';

const [NotificationsProvider, useNotifications] = createContext<Notification[]>({
  name: 'NotificationsContext',
  errorMessage:
    'useNotfications: `notifications` is undefined. Seems you forgot to wrap the app in `<NotificationsProvider />` ',
});
export { NotificationsProvider, useNotifications };
